export default "__VITE_ASSET__MWyoyKWH__"